import { render, staticRenderFns } from "./GoodReceive.vue?vue&type=template&id=645d1d0c&"
import script from "./GoodReceive.vue?vue&type=script&lang=js&"
export * from "./GoodReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports